interface CookieOptions {
  domain?: string;
  path?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
  maxAge?: number;
}

const defaultCookieOptions: CookieOptions = {
  path: '/',
  sameSite: 'Strict',
  secure: process.env.NODE_ENV !== 'development',
  maxAge: 60
};
export class Cookies {

  private static readonly stringifyOptions = (options?: CookieOptions): string => {
    if (!options) return '';
    const opts: string[] = [];
    if (options.domain) {
      opts.push(`Domain=${options.domain}`);
    }
    if (options.path) {
      opts.push(`Path=${options.path}`);
    }
    if (options.secure) {
      opts.push('Secure');
    }
    if (options.sameSite) {
      opts.push(`SameSite=${options.sameSite}`);
    }
    if (options.maxAge) {
      opts.push(`Max-Age=${options.maxAge}`);
    }
    return opts.join('; ');
  };

  static set(name: string, value: string, options?: CookieOptions) {
    const cookieData = `${name}=${value}`;
    document.cookie = `${cookieData}; ${this.stringifyOptions({ ...defaultCookieOptions, ...options })}`;
  }

  static get(name: string): string | undefined {
    const match = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${name}=`));
    return match?.split('=')[1];
  }

  static remove (name: string, options?: CookieOptions) {
    document.cookie = `${name}=; ${this.stringifyOptions({ ...defaultCookieOptions, ...options })}`;
  }
}